module.exports = __webpack_public_path__ + "assets/img/3ec1a21621532e8a23e84f1cf19ab3e0.png";